export default {
  // #region exp
  GET_EXPERIENCES_OPTIONS_REQUEST: 'GET_EXPERIENCES_OPTIONS_REQUEST',
  GET_EXPERIENCES_OPTIONS_SUCCESS: 'GET_EXPERIENCES_OPTIONS_SUCCESS',
  GET_EXPERIENCES_OPTIONS_FAILURE: 'GET_EXPERIENCES_OPTIONS_FAILURE',
  //#endregion

  // #region salary
  GET_SALARY_OPTIONS_REQUEST: 'GET_SALARY_OPTIONS_REQUEST',
  GET_SALARY_OPTIONS_SUCCESS: 'GET_SALARY_OPTIONS_SUCCESS',
  GET_SALARY_OPTIONS_FAILURE: 'GET_SALARY_OPTIONS_FAILURE',
  //#endregion

  // #region salary
  GET_LEVEL_OPTIONS_REQUEST: 'GET_LEVEL_OPTIONS_REQUEST',
  GET_LEVEL_OPTIONS_SUCCESS: 'GET_LEVEL_OPTIONS_SUCCESS',
  GET_LEVEL_OPTIONS_FAILURE: 'GET_LEVEL_OPTIONS_FAILURE',
  //#endregion

  // #region position
  GET_POSITIONS_REQUEST: 'GET_POSITIONS_REQUEST',
  GET_POSITIONS_SUCCESS: 'GET_POSITIONS_SUCCESS',
  GET_POSITIONS_FAILURE: 'GET_POSITIONS_FAILURE',

  GET_POSITION_REQUEST: 'GET_POSITION_REQUEST',
  GET_POSITION_SUCCESS: 'GET_POSITION_SUCCESS',
  GET_POSITION_FAILURE: 'GET_POSITION_FAILURE',

  CREATE_POSITION_REQUEST: 'CREATE_POSITION_REQUEST',
  CREATE_POSITION_SUCCESS: 'CREATE_POSITION_SUCCESS',
  CREATE_POSITION_FAILURE: 'CREATE_POSITION_FAILURE',

  UPDATE_POSITION_REQUEST: 'UPDATE_POSITION_REQUEST',
  UPDATE_POSITION_SUCCESS: 'UPDATE_POSITION_SUCCESS',
  UPDATE_POSITION_FAILURE: 'UPDATE_POSITION_FAILURE',

  DELETE_POSITION_REQUEST: 'DELETE_POSITION_REQUEST',
  DELETE_POSITION_SUCCESS: 'DELETE_POSITION_SUCCESS',
  DELETE_POSITION_FAILURE: 'DELETE_POSITION_FAILURE',
  // #endregion
};
